import React from 'react';
import ReportingMembershipsGrowthPage from '../components/ReportingMembershipsGrowthPage';

const ReportingMembershipsGrowthApp = (props) => (
  <ReportingMembershipsGrowthPage {...props} />
);

export default ReportingMembershipsGrowthApp;
